import { ExternalLink } from "@octopusdeploy/design-system-components";
import { LearnMoreResources, TopicsContainer } from "../../CommonComponents/CommonViews";
export const ProjectVersionControlSettingsTopics = () => (<TopicsContainer>
        <LearnMoreResources>
            <div>
                <ExternalLink href="ConfigAsCodeConfiguration">Connecting projects to Git</ExternalLink>
            </div>
            <div>
                <ExternalLink href="ConfigAsCodeMoving">Moving version control</ExternalLink>
            </div>
            <div>
                <ExternalLink href="GitHubApp">GitHub App</ExternalLink>
            </div>
        </LearnMoreResources>
    </TopicsContainer>);
